import React from "react"
import * as S from "./about-us-hero.styles"
import { Grid, useMediaQuery } from "@mui/material"
import parse from "html-react-parser"
import { useTheme } from "@emotion/react"

const AboutUsHero = ({ title, description, image, addBackgroundColor }) => {
  const theme = useTheme()
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"))

  return (
    <S.Section className={addBackgroundColor && "bg-color"}>
      <S.Wrapper maxWidth="xl">
        <S.BgImage
          alt={title}
          arPaddingPercentage={isDesktop ? 38 : 70}
          img={image}
        />
        {(title || description) && (
          <S.TextWrapper>
            <Grid container spacing={{ md: 8, xs: 2 }}>
              <Grid xs={12} md={5.5} item>
                <S.Title>{title}</S.Title>
              </Grid>
              <Grid xs={12} md={6.5} item>
                {description && (
                  <S.Description>{parse(description)}</S.Description>
                )}
              </Grid>
            </Grid>
          </S.TextWrapper>
        )}
      </S.Wrapper>
    </S.Section>
  )
}

export default AboutUsHero
